import { HSLColor } from '@yola/yola-palette-generator';
import parseTemplate from './parse-template';
import parseHslaColorString from './parse-hsla-color-string';
import isCssVariable from '../verifiers/is-css-variable';

const parseColors = (template, context, colorsOverrides) => {
  const stringColors = parseTemplate(template, context);
  const hslaColors = Object.entries(stringColors).reduce((acc, [key, stringColor]) => {
    if (isCssVariable(stringColor)) {
      acc[key] = stringColor;
    } else {
      const { h, s, l, a } = parseHslaColorString(stringColor);
      acc[key] = new HSLColor(h, s, l, a);
    }

    return acc;
  }, {});
  return { ...hslaColors, ...colorsOverrides };
};

export default parseColors;
